import React from "react";
import {
  ArticleHierarchy,
  useArticleHierarchy,
} from "../../utils/article-hierarchy";
import { ArticleCardList } from "../article-card-list";

export const DescendantList: React.FC<{
  articleId: string;
  title?: string | null;
  directChildrenOnly?: boolean;
}> = ({ articleId, title, directChildrenOnly }) => {
  const { getDescendantsForArticleId } = useArticleHierarchy();
  const descendants = getDescendantsForArticleId(articleId);
  // console.log({ descendants });
  if (!descendants) return null;
  if (!directChildrenOnly) {
    const appendChildrenToDescendants = (article: ArticleHierarchy) => {
      if (article.children) {
        for (const child of article.children) {
          descendants.push(child);
          appendChildrenToDescendants(child);
        }
      }
    };
    for (const article of descendants) {
      appendChildrenToDescendants(article);
    }
  }
  return <ArticleCardList title={title || ""} articles={descendants} />;
};
